import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { memoForm2ApiMapper } from '../../MemoBeforeSubmit/mappers/memo.form2api.mapper';

import type { MoveToGroupValues } from '../MoveToGroup';
import type { MoveToGroupMutation } from '../types/props.type';
import type { SubmitHandler } from '../types/submit-handler.type';

import { useDirectMutationCallbacks } from './useDirectMutationCallbacks.hook';

interface Params {
  readonly mutation: MoveToGroupMutation;
  readonly onSuccess: () => void;
  readonly queryKeysToInvalidate: readonly (readonly string[])[];
  readonly serviceUserId: Id;
}

export const useMoveToGroupSubmit = ({
  mutation,
  onSuccess,
  queryKeysToInvalidate,
  serviceUserId,
}: Readonly<Params>) => {
  const buildCallbacks = useDirectMutationCallbacks({
    onSuccess,
    queryKeysToInvalidate,
  });

  const handleSubmitFactory = useCallback(
    (serviceUsageId: Id): SubmitHandler<MoveToGroupValues> =>
      ({ values, memos, formikHelpers: { setSubmitting }, setFormError }) => {
        setFormError(null);

        mutation(
          {
            serviceUsageId,
            serviceUserId,
            targetServiceUsagesGroupId: values.targetServiceUsagesGroupId,
            versionData: memoForm2ApiMapper(memos),
          },
          buildCallbacks({
            setFormError,
            setSubmitting,
            successMessage: 'La prestation a bien été déplacée.',
          }),
        );

        return undefined;
      },
    [buildCallbacks, mutation, serviceUserId],
  );

  return { handleSubmitFactory };
};
